var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20 10.227c0-.709-.065-1.39-.186-2.045h-9.61v3.873h5.492c-.242 1.245-.965 2.3-2.05 3.009v2.518h3.311c1.93-1.746 3.043-4.31 3.043-7.355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.204 20c2.755 0 5.065-.89 6.753-2.418l-3.311-2.518c-.91.6-2.069.963-3.442.963-2.653 0-4.907-1.754-5.714-4.118H1.095v2.582C2.774 17.755 6.215 20 10.205 20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.49 11.9a5.9 5.9 0 0 1-.325-1.9c0-.664.12-1.3.325-1.9V5.518H1.095a9.72 9.72 0 0 0 0 8.964l2.643-2.018z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10.204 3.982c1.503 0 2.839.509 3.906 1.49l2.922-2.863C15.26.991 12.959 0 10.204 0c-3.989 0-7.43 2.245-9.11 5.518L4.49 8.1c.807-2.364 3.061-4.118 5.714-4.118"
  })));
};
export default SvgGoogle;